export interface ServerSymbolPosition {
	reel: number;
	row: number;
}

export interface ServerWinSymbols {
	symbol: number;
	position: ServerSymbolPosition;
}

export class ServerWinLine {
	protected _winSymbols: ServerWinSymbols[];
	protected _mainWinSymbol: number;
	protected _win: number;
	protected _multiplier: number;

	constructor() {
		this._win = 0;
		this._winSymbols = [];
		this._mainWinSymbol = -1;
		this._multiplier = 0;
	}

	public addWinPosition(reel: number, row: number, symbol: number): void {
		const position: ServerSymbolPosition = {reel, row};
		this._winSymbols.push({position, symbol});
	}

	public get winSymbols(): ServerWinSymbols[] {
		return this._winSymbols;
	}

	public get win(): number {
		return this._win;
	}

	public set win(value: number) {
		this._win = value;
	}

	public get mainWinSymbol(): number {
		return this._mainWinSymbol;
	}

	public set mainWinSymbol(value: number) {
		this._mainWinSymbol = value;
	}

	public get multiplier(): number {
		return this._multiplier;
	}

	public set multiplier(value: number) {
		this._multiplier = value;
	}
}


// WEBPACK FOOTER //
// ./@fantasmagames/prototype/src/win/ServerWinLine.ts